<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'8-5'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>메뉴 관리 - 단체여행 문의 관리</p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn02" v-on:click="edit">상세확인</button>
          </div>
        </div>
        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_group_inquiry
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminGroupInquiryManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  methods: {
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `/AdminGroupInquiryManagementAdd?group_inquiry_ID=${this.tabulator.getSelectedData()[0].group_inquiry_ID}`
      }
    }
  },
  mounted () {
    get_group_inquiry().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        movableRows: true,
        columns: [
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: 'ID', field: 'group_inquiry_ID', headerSort: false},
          {title: '문의자명', field: 'group_inquiry_write', headerSort: false},
          {title: '휴대폰번호', field: 'group_inquiry_phone_number', headerSort: false},
          {title: '이메일', field: 'group_inquiry_email', headerSort: false},
          {
            title: '예상인원',
            field: 'group_inquiry_expected_number',
            headerSort: false,
            hozAlign: 'right',
            formatter: function (cell) {
              let value = cell.getValue()
              return value.toLocaleString() + '명'
            }
          },
          {title: '여행기간 시작일', field: 'group_inquiry_start_date', headerSort: false},
          {title: '여행기간 종료일', field: 'group_inquiry_end_date', headerSort: false},
          {title: '여행기간 종료일', field: 'group_inquiry_end_date', headerSort: false},
          {
            title: '여행경비',
            field: 'group_inquiry_expected_expenses',
            headerSort: false,
            hozAlign: 'right',
            formatter: function (cell) {
              let value = cell.getValue()
              return value.toLocaleString() + '만원'
            }
          },
          {title: '희망지역', field: 'group_inquiry_desired_area', headerSort: false},
          {title: '남기실말씀', field: 'group_inquiry_word_advice', headerSort: false},
          {title: '작성일', field: 'group_inquiry_registe', headerSort: false},
          {title: '수정일', field: 'group_inquiry_modified', headerSort: false}
        ]
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CommunityManagement/AdminGroupInquiryManagement.vue